module.exports = __webpack_public_path__ + "media/images/flags/16/Somalia-5bba2c8af52633ff703ec11fc68e70a5.png";